import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, MoveLeft, MoveRight } from 'lucide-react';
import ViewConfig from '../../config/viewConfig';
import SaidaButton from "./arrowButton";

const CardCarousel = ({ data = [], renderCard, onSlideChange, autoPlay = false, autoPlayDelay = 3000, className = '', setHeight = '320px', clickableCards = true, maxItems = null, settingDefault = true, mobileView, isFlat = false }) => {
    // Sample data - you can replace this with your actual data
    const items = data?.length > 0 ? data : [
        {
            id: 1,
            title: 'Cosmetics',
            count: 99,
            image: '🧴',
            bgColor: 'bg-white'
        },
        {
            id: 2,
            title: 'Beverage',
            count: 99,
            image: '🍼',
            bgColor: 'bg-white'
        },
        {
            id: 3,
            title: 'Food Jars',
            count: 80,
            image: '🥛',
            bgColor: 'bg-white'
        },
        {
            id: 4,
            title: 'Electronics',
            count: 65,
            image: '📱',
            bgColor: 'bg-white'
        },
        {
            id: 5,
            title: 'Books',
            count: 120,
            image: '📚',
            bgColor: 'bg-white'
        }
    ];
    const displayItems = maxItems ? items.slice(0, maxItems) : items;
    const [currentIndex, setCurrentIndex] = useState(1); // Start at 1 to show middle card initially
    const [isAnimating, setIsAnimating] = useState(false);

    const goToNext = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        const newIndex = currentIndex === displayItems.length - 1 ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
        onSlideChange?.(newIndex);
    };

    const goToPrev = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        const newIndex = currentIndex === 0 ? displayItems.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
        onSlideChange?.(newIndex);
    };


    const goToSlide = (index) => {
        if (isAnimating || index === currentIndex) return;
        setIsAnimating(true);
        setCurrentIndex(index);
        onSlideChange?.(index);
    };

    useEffect(() => {
        if (autoPlay && !isAnimating) {
            const interval = setInterval(goToNext, autoPlayDelay);
            return () => clearInterval(interval);
        }
    }, [autoPlay, autoPlayDelay, isAnimating, currentIndex]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsAnimating(false);
        }, 300);
        return () => clearTimeout(timer);
    }, [currentIndex]);

    const getCardStyle = (index) => {
        const diff = index - currentIndex;
        const isCurrent = diff === 0;
        const isPrev = diff === -1 || (currentIndex === 0 && index === displayItems.length - 1);
        const isNext = diff === 1 || (currentIndex === displayItems.length - 1 && index === 0);

        if (isCurrent) {
            return {
                transform: 'translateX(0%) scale(1)',
                zIndex: 3,
                opacity: 1
            };
        } else if (isPrev) {
            return {
                transform: isFlat ? 'translateX(-104%) translateY(0%) scale(1)' : settingDefault ? 'translateX(-104%) translateY(10%) scale(0.85)' : 'translateX(-104%) translateY(40%) scale(0.9)',
                zIndex: 1,
                opacity: mobileView ? 0 : settingDefault ? 0.8 : 1
            };
        } else if (isNext) {
            return {
                transform: isFlat ? 'translateX(104%) translateY(0%) scale(1)' : settingDefault ? 'translateX(104%) translateY(10%) scale(0.85)' : 'translateX(104%) translateY(40%) scale(0.9)',
                zIndex: 1,
                opacity: mobileView ? 0 : settingDefault ? 0.8 : 1
            };
        } else {
            return {
                transform: 'translateX(0%) scale(0)',
                zIndex: 0,
                opacity: 0
            };
        }
    };


    return (
        <div className={`w-full relative ${className}`}>
            {/* Carousel Container */}
            <div className={"relative overflow-hidden"} style={setHeight?{ height: setHeight }:{}}>
                <div className="relative w-full h-full flex justify-center">
                    {displayItems.map((item, index) => (
                        <div
                            key={item.id || index}
                            className="absolute flex-1 h-64 cursor-pointer transition-all duration-700 ease-in-out"
                            style={getCardStyle(index)}
                            onClick={clickableCards ? () => goToSlide(index) : null}
                        >
                            {renderCard(item, index, index === currentIndex)}
                        </div>
                    ))}
                </div>
            </div>

            {/* Navigation Arrows */}
            <div className="flex justify-center items-center md:-mt-12 space-x-8 md:space-x-6 relative z-40">
                
                 <SaidaButton direction="left" onClick={goToPrev} />

                 <SaidaButton direction="right" onClick={goToNext} />

            </div>
        </div>
    );
}

export default CardCarousel;